import { useEffect, useState } from 'react';

export function useFeltLoading(isLoading: boolean, ms = 650) {
    const [holding, setHolding] = useState(true);

    useEffect(() => {
        if (isLoading) {
            setHolding(true);
            return;
        }
        const timer = window.setTimeout(() => setHolding(false), ms);
        return () => window.clearTimeout(timer);
    }, [isLoading, ms]);

    return isLoading || holding;
}
